import React from "react";
import { Provider } from "react-redux";

import "flag-icon-css/css/flag-icon.min.css";

import { store } from "App/state";
import { Router } from "App/router";
import { GlobalStyle } from "shared/styles";
import { ErrorBoundary } from "shared/components";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const App: React.FC = () => {
  return (
    <>
      <GlobalStyle />
      <ErrorBoundary>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <Router />
          </QueryClientProvider>
        </Provider>
      </ErrorBoundary>
    </>
  );
};
